import {Component, Input} from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";
import {ApiServiceService} from "../../../Services/api-service.service";
import {AngularEditorConfig} from "@kolkov/angular-editor";

@Component({
  selector: 'app-user-comment-global',
  templateUrl: './user-comment-global.component.html',
  styleUrls: ['./user-comment-global.component.css']
})
export class UserCommentGlobalComponent {
  @Input() assessmentId;
  @Input() canWrite:boolean = true;
  comments:any[]=[];
  sending: boolean;

  ngOnInit(): void {
    this.getAssessmentComments();
  }
  constructor(
      private sanitizer: DomSanitizer,
      private apiService: ApiServiceService,
  ) {
  }

  getAssessmentComments(){
    const url = `/assessments/all/comments?assessmentId=${this.assessmentId}`;
    this.apiService.get(url).subscribe(
        (response) => {
          this.comments = (response || []).map((c) => ({
            ...c,
            comment: this.sanitizeHtml(c?.comment || ''),
          }));
        },
        (error) => {
          console.log(error)
        }
    );
  }

  saveAssessmentComments(){
    this.sending = true;
    if (this.htmlContent==""){
      this.sending = false;
      return;
    }
    const url = `/assessments/all/comments?assessmentId=${this.assessmentId}`;
    this.apiService.post(url, this.htmlContent).subscribe(
        (response) => {
          this.getAssessmentComments();
          this.sending = false;
          this.clearText()
        },
        (error) => {
        }
    );
  }

  htmlContent = '';

  // Editor configuration
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '5rem',
    maxHeight: '15rem',
    width: 'auto',
    minWidth: '0',
    placeholder: 'Leave a comment here...',
    translate: 'yes',
    sanitize:true,
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
  };
  show: boolean = false;

  clearText() {
    this.htmlContent ='';
  }

  sanitizeHtml(html: string):any {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  changeStatus(){
    this.show = !this.show;
  }

}
